import $i18n from '@/locales/i18n';
import Icon from './logo';
import { createAsideSnippet, createHeaderSnippet, getObjectSetterSnippet, } from '@/common/manager/setter-snippet';
import { PAGE_ASIDE, PAGE_CONTENT } from '@/common/util/const';
const CnLayoutPagePrototype = {
    title: $i18n.get({ id: 'NaturalLayoutPage', dm: '自然布局页面' }),
    componentName: 'CnLayoutPage',
    icon: Icon,
    docUrl: '',
    isContainer: true,
    disableBehaviors: '*',
    initialChildren: [
        {
            componentName: 'CnLayoutContent',
            props: {
                isCnLayoutContent: true,
            },
        },
    ],
    configure: [
        {
            name: 'isCnLayoutPage',
            title: 'CnLayoutPage',
            initialValue: true,
            display: 'none',
        },
        {
            name: '_context',
            title: $i18n.get({ id: 'Context', dm: '上下文' }),
            initialValue: {
                type: 'JSExpression',
                value: 'this',
            },
            display: 'none',
        },
        {
            title: $i18n.get({ id: 'Style', dm: '样式' }),
            display: 'accordion',
            collapsed: false,
            setter: getObjectSetterSnippet({
                items: [
                    {
                        name: 'header',
                        title: $i18n.get({ id: 'OpenHeader', dm: '开启页头' }),
                        display: 'inline',
                        setter: 'BoolSetter',
                        extraProps: {
                            setValue: (target, value) => {
                                const pageNode = target.node;
                                const node = pageNode?.children?.find((n) => n.componentName === 'CnLayoutHeader');
                                if (value && !node) {
                                    const navSnippets = createHeaderSnippet();
                                    const node2 = pageNode?.document?.createNode(navSnippets);
                                    const insertNode = pageNode?.children?.get(0);
                                    node2 && insertNode && pageNode?.insertBefore(node2, insertNode, false);
                                }
                                else if (!value && node) {
                                    node.remove();
                                }
                            },
                        },
                    },
                    {
                        name: 'aside',
                        title: $i18n.get({ id: 'OpenSidebar', dm: '开启侧边栏' }),
                        display: 'inline',
                        setter: 'BoolSetter',
                        extraProps: {
                            setValue: (target, value) => {
                                const pageNode = target.node;
                                const node = pageNode?.children?.find((n) => n.componentName === PAGE_CONTENT);
                                if (node) {
                                    if (value) {
                                        const asideSnippets = createAsideSnippet();
                                        const node2 = pageNode?.document?.createNode(asideSnippets);
                                        node2 && pageNode?.insertBefore(node2);
                                    }
                                    else {
                                        const asideNode = pageNode?.children
                                            ?.find((n) => n.componentName === PAGE_ASIDE)
                                            ?.getNode?.();
                                        asideNode?.remove();
                                    }
                                }
                            },
                        },
                    },
                ],
            }),
        },
    ],
};
// 原型配置请参考：https://lark.alipay.com/vision/docs/prototype
export { CnLayoutPagePrototype };
